import Vue from "vue";
import {
    carouselComponentComputed,
    carouselComponentData,
    carouselComponentDefinition,
    carouselComponentMethods,
} from "./carousel/carousel";

let element = document.getElementById('header-carousel-block');

let widget = element ? new Vue({
    ...carouselComponentDefinition,
    el : '#header-carousel-block',
    computed : {
        // We need to do this, otherwise each carousel shares the same 'computed' object,
        // as the component definition is only shallow copied.
        ...carouselComponentComputed
    },
    data : {
        // We need to do this, otherwise each carousel shares the same 'data' object,
        // as the component definition is only shallow copied.
        ...carouselComponentData,
        label : 'header'
    },
    methods : {
        ...carouselComponentMethods,
        onMounted : function() {
            // this is where we can do browser capability checks.
            if( ! ('getComputedStyle' in window) ) {
                console.warn('Erk, this browser does not support getComputedStyle()');
                return false;
            }
        },
        onBeforeBoot : function() {
            this.slides.map( slide => {
                console.log("slide", slide);
                // We check for getComputedStyleSupport() in onMounted()
                // so we can use it here without worrying...
                const bg_color = window
                    .getComputedStyle( slide )
                    .getPropertyValue( 'background-color' )
                ;
                slide.setAttribute( 'data-bg-color', bg_color );
                slide.style.backgroundColor = 'transparent';
            });
            this.setBackgroundTo( this.getActiveSlide() );
        },
        onBeforeTransition : function( outgoing, incoming ) {
            this.setBackgroundTo( incoming );
        },
        setBackgroundTo : function( slide ) {
            this.$el.style.backgroundColor = slide.getAttribute('data-bg-color');
        },
    }
}) : null ;
